import { render, staticRenderFns } from "./StmsClientReplyView.vue?vue&type=template&id=9c82aa5e&scoped=true&"
import script from "./StmsClientReplyView.vue?vue&type=script&lang=js&"
export * from "./StmsClientReplyView.vue?vue&type=script&lang=js&"
import style0 from "./StmsClientReplyView.vue?vue&type=style&index=0&id=9c82aa5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c82aa5e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VChip,VForm,VIcon})
